import { render, staticRenderFns } from "./CockpitPage.vue?vue&type=template&id=b8b91dd6&scoped=true&lang=pug&"
import script from "./CockpitPage.vue?vue&type=script&lang=ts&"
export * from "./CockpitPage.vue?vue&type=script&lang=ts&"
import style0 from "./CockpitPage.vue?vue&type=style&index=0&id=b8b91dd6&lang=stylus&scoped=true&"
import style1 from "./CockpitPage.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b91dd6",
  null
  
)

export default component.exports